import { useEffect, useRef } from 'react';
import { createTransport, createXResolveProvider, Transport } from '@spotify-internal/transport';

import auth from '../../lib/shared/auth/auth';

export const useTransport = () => {
  const transportRef = useRef<Transport>();

  useEffect(() => {
    transportRef.current = createTransport({
      providers: {
        endpoints: createXResolveProvider(),
        token: () => auth.tokenProvider(),
      },
    });
  }, []);

  return transportRef.current;
};
